<div class="app-container" [class.light-header]="isThemeHeaderLight">
  <!-- Top navbar -->
  <lh-navbar></lh-navbar>

  <!-- Angular router outlet -->
  <router-outlet (attach)="onAttach($event)" (detach)="onDetach($event)"></router-outlet>

  <!-- Bottom tab bar -->
  @if (isTabbedNavigationEnabled) {
    <lh-tab-bar></lh-tab-bar>
  }

  <!-- Intercom widget -->
  @if (isIntercomEnabled) {
    <div id="intercomTrigger" class="intercom-trigger" [hidden]="isTabbedNavigationEnabled">
      <span class="chat-widget-header">{{ 'CHAT_WIDGET_HEADER' | translate }}</span>
    </div>
  }
</div>

<div class="app-version">
  <span>v{{ appVersion }}</span>
</div>

<!-- Session URL setting overrides, when any are active (AM-4658) -->
<lh-app-settings-override-indicator />
